/**
 * @generated SignedSource<<5165e4179aa5802067018306a82984ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$data = {
  readonly __typename: "Article";
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
      readonly name?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
} | {
  readonly __typename: "Section";
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase";
};
export type atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$key = {
  readonly " $data"?: atomsCurrentStyleCardCarouselWidgetSectionsAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentStyleCardCarouselWidgetSectionsAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase"
};

(node as any).hash = "d7f7aeb8ba441b69520b4168e9a9b093";

export default node;
